import React from 'react';
import { useTrace } from '../../context/TraceContext';
import { Badge } from '../ui/badge';
import { cn } from '../../lib/utils';

// Component-level trace label that appears when PID Trace Mode is ON
const TraceLabel = ({ prd, req, className, position = 'top-right' }) => {
  const { pidTraceMode, openTraceInspector } = useTrace();

  if (!pidTraceMode) return null;

  const positionClasses = {
    'top-right': 'top-1 right-1',
    'top-left': 'top-1 left-1',
    'bottom-right': 'bottom-1 right-1',
    'bottom-left': 'bottom-1 left-1'
  };

  return (
    <div 
      className={cn(
        "absolute z-10 flex flex-wrap gap-1",
        positionClasses[position],
        className
      )}
    >
      {prd && (
        <Badge 
          className="bg-cyan-950/90 text-cyan-400 border border-cyan-800 px-1.5 py-0 text-[9px] font-mono cursor-pointer hover:bg-cyan-900"
          onClick={(e) => {
            e.stopPropagation();
            openTraceInspector({ type: 'prd', ref: prd });
          }}
        >
          {prd}
        </Badge>
      )}
      {req && (
        <Badge 
          className="bg-emerald-950/90 text-emerald-400 border border-emerald-800 px-1.5 py-0 text-[9px] font-mono cursor-pointer hover:bg-emerald-900"
          onClick={(e) => {
            e.stopPropagation();
            openTraceInspector({ type: 'req', id: req });
          }}
        >
          {req}
        </Badge>
      )}
    </div>
  );
};

export default TraceLabel;
